import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';
import * as _ from 'lodash';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McRisOrderService {
  constructor(
    private sdk: MycureSDK,
  ) {

  }

  loadOrder(id: string) {
    const query = {
      id,
      $populate: {
        tests: {
          service: 'ris-tests', key: 'tests'
        }
      }
      // $populate: {
      //   _technician: {
      //     key: 'id',
      //     servce: 'personal-details',
      //     method: 'findOne'
      //   },
      //   _sonologist: {
      //     key: 'id',
      //     servce: 'personal-details',
      //     method: 'findOne'
      //   }
      // }
    }
    return this.sdk.ris.orders().findOne(query);
  }

  async loadPendingOrders(patient: string) {
    const query = { 
      patient, $pending: true,
      $populate: {
        tests: {
          service: 'ris-tests', key: 'tests'
        }
      }
    };

    let res: any = await this.sdk.ris.orders().find(query);
    res.items = res.items.map((order: any) => {
      return {
        ..._.omit(order, ['$populated']),
        _tests: order.$populated.tests || [],
      }
    });

    return res;
  }

  async loadOrders(facility: string, status: string, filter: any) {
    let query: any = { 
      facility, $sort: { 'createdAt': -1 },
      $populate: {
        tests: {
          service: 'ris-tests', key: 'tests'
        }
      }
    };

    // filter by status
    if (status == 'completed') {
      query = {
        ...query,
        completedAt: { $exists: true },
        verifiedAt: { $exists: false },
        finalizedAt: { $exists: false },
        sentOutAt: { $exists: false },
      };
    } else if (status == 'finalized') {
      query = {
        ...query,
        completedAt: { $exists: true },
        finalizedAt: { $exists: true },
        verifiedAt: { $exists: true },
        sentOutAt: { $exists: false },
      };
    } else if (status == 'verified') {
      query = {
        ...query,
        completedAt: { $exists: true },
        verifiedAt: { $exists: true },
        finalizedAt: { $exists: false },
        sentOutAt: { $exists: false },
      };
    } else if (status == 'sendout') {
      query = {
        ...query,
        sentOutAt: { $exists: true },
      };
    } else if (status == 'pending') {
      query[`$pending`] = true;
    }

    if (filter && filter.start && filter.end) {
      let start = new Date(filter.start); start.setHours(0, 0, 0, 0);
      let end = new Date(filter.end); end.setHours(23, 59, 59, 0);
      query = {
        ...query,
        createdAt: { $lte: end, $gte: start },
        $dateFields: ['createdAt.$gte', 'createdAt.$lte']
      };
    }

    let res: any = await this.sdk.ris.orders().find(query);
    res.items = res.items.map((order: any) => {
      const tests = order.$populated.tests || [];
      const names = tests.map((item: any) => item.name) || [];

      return {
        ..._.omit(order, ['$populated']),
        _testsNames: names.join(', ')
      }
    });

    return res;
  }

  async createResult(data: any, updatedStatus: string = undefined, token: string = undefined) {
    if (!data.id || !data.report || !data.tests || data.tests.length == 0) throw new Error('no order found');

    // update existing results
    await this.updateResult(data, token);

    let update: any = _.pick(_.pickBy(data, _.identity), ['imageLocation', 'technician', 'radiologist', 'sonologist']);
    
    // get all tests and set report as value
    let results: any[] = []; const orderReport: any = data.report;
    data.tests.map((testId: string) => {
      results.push({ test: testId, value: orderReport });
    });
    update = { ...update, $addToSet: { results: { $each: results } } };

    // update order status
    if (updatedStatus) {
      if (updatedStatus == 'finalize') update['finalize'] = true;
      if (updatedStatus == 'sendout') update['sendOut'] = true;
      if (updatedStatus == 'complete') update['complete'] = true;
      if (updatedStatus == 'verify') update['verify'] = true;
    }

    // if has token return an update with custom token
    if (token) {
      return this.sdk.ris.orders().update(data.id, update, { accessToken: token });
    }

    return this.sdk.ris.orders().update(data.id, update);
  }

  private async updateResult(data: any, token: string = undefined) {
    // remove existing results, if has results already.
    if (data.results && data.results.length != 0) {
      const existingResultId = data.results.map((item: any) => item.id);
      const update: any = { $pull: { results: { id: { $in: existingResultId } } } };

      if (token) {
        return this.sdk.ris.orders().update(data.id, update, { accessToken: token });
      }

      return this.sdk.ris.orders().update(data.id, update);
    }
  }

  removeOrder(id: string) {
    return this.sdk.ris.orders().remove(id);
  }
}
